<template>
  <div class="documentation">
    <sidebar-menu />
    <div class="documentation__main container-router">
      <router-view />
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/SideBar/Desktop"

export default {
  name: `adx-documentation`,
  components: {
    'sidebar-menu': SideBar
  },
  data() {
    return {
      
    }
  }
}
</script>

<style lang="scss">
@import "~@/styles/documentation";
@import "./index.scss";
</style>
